// Clone modal — opens CreateGridModal pre-filled from source grid config.
import type { GridConfig } from "@/types/api";
import CreateGridModal from "@/components/grid/create-grid-modal";

interface CloneGridModalProps {
  sourceGrid: GridConfig;
  onClose: () => void;
}

export default function CloneGridModal({ sourceGrid, onClose }: CloneGridModalProps) {
  return (
    <CreateGridModal
      onClose={onClose}
      initial={{
        symbol: sourceGrid.symbol,
        lower_price: sourceGrid.lower_price,
        upper_price: sourceGrid.upper_price,
        grid_count: sourceGrid.grid_count,
        quantity_per_grid: sourceGrid.quantity_per_grid,
        leverage: sourceGrid.leverage,
        side: sourceGrid.side,
        trailing: !!sourceGrid.trailing,
        spacing: sourceGrid.spacing,
        atr_multiplier: sourceGrid.atr_multiplier,
        max_hold_minutes: sourceGrid.max_hold_minutes,
        force_exit_minutes: sourceGrid.force_exit_minutes,
        max_deviation_pct: sourceGrid.max_deviation_pct,
      }}
    />
  );
}
